// Export all models from a single entry point
export * from './banner.model';
export * from './news.model';
export * from './material-type.model';
export * from './suggestion-type.model';
export * from './documentation.model';
export * from './campaign.model';
export * from './activity.model';
export * from './configuration.model';
export * from './email-notification.model';
export * from './regla-rappel.model';
export * from './incentive-travel.model';
export * from './incentive-travel-requirement.model';
export * from './incentive-travel-point.model';
export * from './incentive-travel.model';
export * from './smtp-config.model';
export * from './whatsapp-config.model';
export * from './line-config.model';
export * from './sms-config.model';
